import React from 'react'

export default function PublicNavbar() {
  return (
    <nav className="navbar navbar-dark bg-primary">
      <div className="container-fluid">
        <a className="navbar-brand">Wellbeing</a>

      </div>
    </nav>
  )
}
